import contactForm from './contact-form.json';

export default {
  contactForm,
};
